import i18n from '../../i18n';
import UserRole from '../../models/enums/user-roles';
import ValidationResult from '@common/interfaces/api/validation-result';

export const validateUserEmail = (
  email: string,
  creating?: boolean,
  registering?: boolean,
): ValidationResult => {
  if (registering === true) {
    return {
      isValid: true,
      error: i18n.t('form-help-text-register-email'),
    };
  }
  if (creating === true) {
    return {
      isValid: true,
      error: i18n.t('form-help-text-user-email'),
    };
  }
  return {
    isValid: true,
    error: i18n.t('form-help-text-user-email-login'),
  };
};

export const validateUserPassword = (password: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-user-password'),
  };
};

export const validateUserRepeatPassword = (
  password: string,
  firstSet: string,
): ValidationResult => {
  if (password !== firstSet && password.length > 0) {
    return {
      isValid: false,
      error: i18n.t('validation-error-passwords-do-not-match'),
    };
  }

  return {
    isValid: true,
    error: i18n.t('form-help-text-user-repeat-password'),
  };
};

export const validateUserFirstName = (name: string, registering?: boolean): ValidationResult => {
  if (registering) {
    return {
      isValid: true,
      error: i18n.t('form-help-text-register-first-name'),
    };
  }
  return {
    isValid: true,
    error: i18n.t('form-help-text-user-first-name'),
  };
};

export const validateUserLastName = (name: string): ValidationResult => {
  return {
    isValid: true,
    error: null,
  };
};

export const validateUserRole = (role: UserRole): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-user-role'),
  };
};

export const validateUserPhoneNumber = (phoneNumber: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-user-phone-number'),
  };
};
